import axios from "axios";

const state = {
  deposit_records: [],
  deposit_settings: {},
  tax_transfers: [],
  pending_tax_amounts: { vat: 0, income_tax: 0, total: 0, deposit_count: 0 },
};

const getters = {
  deposit_records: (state) => state.deposit_records,
  deposit_settings: (state) => state.deposit_settings,
  tax_transfers: (state) => state.tax_transfers,
  pending_tax_amounts: (state) => state.pending_tax_amounts,
};

const actions = {
  async get_deposit_records({ commit }) {
    const response = await axios.get("deposit_records");
    commit("SET_DEPOSIT_RECORDS", response.data);
    return response.data;
  },

  async add_deposit_record({ commit }, request) {
    const response = await axios.post("deposit_record", request);
    commit("ADD_DEPOSIT_RECORD", response.data);
    return response.data;
  },

  async edit_deposit_record({ commit }, request) {
    const response = await axios.put("deposit_record", request);
    commit("EDIT_DEPOSIT_RECORD", response.data);
    return response.data;
  },

  async delete_deposit_record({ commit }, id) {
    await axios.delete("deposit_record/" + id);
    commit("DELETE_DEPOSIT_RECORD", id);
  },

  async post_deposits({ commit }, deposit_ids) {
    const response = await axios.post("deposit_records/post", {
      deposit_ids,
    });
    // Update each posted record in state
    const postedRecords = response.data;
    if (Array.isArray(postedRecords)) {
      postedRecords.forEach((record) => {
        commit("EDIT_DEPOSIT_RECORD", record);
      });
    }
    return response.data;
  },

  async get_deposit_settings({ commit }) {
    const response = await axios.get("deposit_settings");
    commit("SET_DEPOSIT_SETTINGS", response.data);
    return response.data;
  },

  async update_deposit_settings({ commit }, settings) {
    const response = await axios.put("deposit_settings", settings);
    commit("SET_DEPOSIT_SETTINGS", response.data);
    return response.data;
  },

  async get_pending_tax_amounts({ commit }) {
    const response = await axios.get("pending_tax_amounts");
    commit("SET_PENDING_TAX_AMOUNTS", response.data);
    return response.data;
  },

  async get_tax_transfers({ commit }) {
    const response = await axios.get("tax_transfers");
    commit("SET_TAX_TRANSFERS", response.data);
    return response.data;
  },

  async create_tax_transfer({ commit, dispatch }, request) {
    const response = await axios.post("tax_transfer", request);
    commit("ADD_TAX_TRANSFER", response.data);
    // Refresh pending amounts after transfer
    await dispatch("get_pending_tax_amounts");
    return response.data;
  },
};

const mutations = {
  SET_DEPOSIT_RECORDS(state, records) {
    state.deposit_records = records;
  },

  ADD_DEPOSIT_RECORD(state, record) {
    state.deposit_records.unshift(record);
  },

  EDIT_DEPOSIT_RECORD(state, record) {
    const index = state.deposit_records.findIndex((r) => r.id == record.id);
    if (index !== -1) {
      state.deposit_records.splice(index, 1, record);
    }
  },

  DELETE_DEPOSIT_RECORD(state, id) {
    state.deposit_records = state.deposit_records.filter((r) => r.id != id);
  },

  SET_DEPOSIT_SETTINGS(state, settings) {
    state.deposit_settings = settings;
  },

  SET_TAX_TRANSFERS(state, transfers) {
    state.tax_transfers = transfers;
  },

  ADD_TAX_TRANSFER(state, transfer) {
    state.tax_transfers.unshift(transfer);
  },

  SET_PENDING_TAX_AMOUNTS(state, amounts) {
    state.pending_tax_amounts = amounts;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
